var path = 'areas/projects/actions/tomcat/Octopus.TomcatDeploy_summary.html';
var html = "<p> Deploy package <strong>{{ packageId }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ feedId }}</em> <span ng-show=isSingleStep>to Tomcat instances in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/tomcat/Octopus.TomcatDeploy_summary.html
// module id = 2798737423227451
// module chunks = 1